export default "__VITE_ASSET__BlmsCoyl__"